export default "__VITE_ASSET__Cm75IzC1__"